<template>
   <div id="noticegl">
       <div class="tos">
          <el-form :inline="true" :model="subjectQueryDto" label-width="100px"  class="demo-form-inline">
             <el-form-item label="关键字：">
                <el-input v-model="subjectQueryDto.keyWord"></el-input>
             </el-form-item>
             <el-form-item>
                <el-button type="primary" @click="sjhsearchFor(subjectQueryDto.keyWord)" plain>查询</el-button>
             </el-form-item>
          </el-form>
          <el-button class="right-item"  type="primary" @click=newoks()>添加公告</el-button>
       </div>
       <div class="tableform">
         <el-table
             :data="tableData"
             border
             stripe
             :cell-style="{'text-align':'center'}"
             :header-cell-style="{'background-color': '#eef1f6','text-align':'center'}"
             style="width: 100%">
             <el-table-column
                prop="subjectTitle"
                label="公告标题"
                >
                <template slot-scope="{row:{ subjectTitle }}">
                {{ subjectTitle|| "—" }}
                </template>
             </el-table-column>
             <el-table-column
                prop="subContent"
                label="公告内容"
                show-overflow-tooltip
                >
                <template slot-scope="{row:{ subContent }}">
                {{ subContent|| "—" }}
                </template>
             </el-table-column>
             <el-table-column
                prop="activeDate"
                label="生效时间"
                >
                <template slot-scope="{row:{ activeDate }}">
                {{ activeDate|| "—" }}
                </template>
             </el-table-column>
             <el-table-column
                prop="endDate"
                label="到期时间"
                >
                <template slot-scope="{row:{ endDate }}">
                {{ endDate|| "—" }}
                </template>
             </el-table-column>
             <el-table-column
                prop="remark"
                label="备注"
                >
                <template slot-scope="{row:{ remark }}">
                {{ remark|| "—" }}
                </template>
             </el-table-column>
             <el-table-column fixed="right" label="操作" width="280">
                <template slot-scope="scope">
                     <i title="编辑" class="el-icon-alixiugai" style="color: #1296db;cursor: pointer;"  @click=bianjiClick(scope.row) ></i>
                     <i title="删除" class="el-icon-alishanchu" style="color: #d81e06;cursor: pointer;"  @click=dels(scope.row) ></i>
                </template>
             </el-table-column>
          </el-table>
          <div class="btnbox">
             <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="subjectQueryDto.pageNum"
                :page-sizes="[10, 15, 20]"
                :page-size="subjectQueryDto.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="this.totals">
             </el-pagination>
          </div>
       </div>
       <!-- 发布公告弹框 -->
       <el-dialog title="发布公告" :visible.sync="increase" width="32%" class="zcyhtk"  @close='closeDialog'>
            <el-form ref="subjectDto" :model="subjectDto" :rules="zcrules" label-width="80px" label-position="right" size="small">
                <el-form-item label="公告标题：" prop="subjectTitle">
                    <el-input v-model="subjectDto.subjectTitle" placeholder="请输入公告标题"></el-input>
                </el-form-item>
                <el-form-item label="副标题：" prop="subhead">
                    <el-input v-model="subjectDto.subhead" placeholder="请输入副标题"></el-input>
                </el-form-item>
                <el-form-item label="公告内容：" prop="subContent">
                    <el-input v-model="subjectDto.subContent" placeholder="请输入公告内容"></el-input>
                </el-form-item>
                <el-form-item label="生效时间：">
                  <el-date-picker
                     v-model="subjectDto.activeDate"
                     type="datetime"
                     format="yyyy-MM-dd HH:mm:ss"
                     value-format="yyyy-MM-dd HH:mm:ss"
                     placeholder="选择日期"
                     align="right"
                     >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="到期时间：">
                  <el-date-picker
                     v-model="subjectDto.endDate"
                     type="datetime"
                     format="yyyy-MM-dd HH:mm:ss"
                     value-format="yyyy-MM-dd HH:mm:ss"
                     placeholder="选择日期"
                     align="right"
                     >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="备注信息：">
                    <el-input v-model="subjectDto.remark" placeholder="请输入备注"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button @click="increase = false">取 消</el-button>
                <el-button type="primary"  @click="submitForm('subjectDto',subjectDto)">确 定</el-button>
            </div>
       </el-dialog>
       <!-- 修改弹框 -->
       <el-dialog title="修改" :visible.sync="dialogFormVisible" width="32%" class="zcyhtk"  @close='closeDialog'>
         <el-form ref="subjectDto" :model="subjectDto" :rules="zcrules" label-width="80px" label-position="right" size="small">
                <el-form-item label="公告标题：" prop="subjectTitle">
                    <el-input v-model="subjectDto.subjectTitle" placeholder="请输入公告标题"></el-input>
                </el-form-item>
                <el-form-item label="副标题：" prop="subhead">
                    <el-input v-model="subjectDto.subhead" placeholder="请输入副标题"></el-input>
                </el-form-item>
                <el-form-item label="公告内容：" prop="subContent">
                  <el-input
                     type="textarea"
                     :autosize="{ minRows: 2, maxRows: 4}"
                     placeholder="请输入公告内容"
                     v-model="subjectDto.subContent">
                     </el-input>
                    <!-- <el-input v-model="subjectDto.subContent" placeholder="请输入公告内容"></el-input> -->
                </el-form-item>
                <el-form-item label="生效时间：">
                  <el-date-picker
                     v-model="subjectDto.activeDate"
                     type="datetime"
                     format="yyyy-MM-dd HH:mm:ss"
                     value-format="yyyy-MM-dd HH:mm:ss"
                     placeholder="选择日期"
                     align="right"
                     >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="到期时间：">
                  <el-date-picker
                     v-model="subjectDto.endDate"
                     type="datetime"
                     format="yyyy-MM-dd HH:mm:ss"
                     value-format="yyyy-MM-dd HH:mm:ss"
                     placeholder="选择日期"
                     align="right"
                     >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="备注信息：">
                    <el-input v-model="subjectDto.remark" placeholder="请输入备注"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button @click="xgtkdfdqx">取 消</el-button>
                <el-button type="primary"  @click="submitForm('subjectDto',subjectDto)">确 定</el-button>
            </div>
       </el-dialog>
   </div>
   </template>
   <script>
      export default {
      name:'noticegl',
      data(){
       return{
          subjectQueryDto:{
             pageNum:1,
             pageSize:10,
             keyWord:null,
             status:0,
          },
          tableData: [],
          totals:10,
          increase:false,
          dialogFormVisible:false,
          subjectDto:{
            activeDate:null,
            endDate:null,
            remark:null,
            subContent:null,
            subhead:null,
            subjectTitle:null,
            status:0,
            subjectId:null
         },
         zcrules: {
            subjectTitle: [
            { required: true, message: '请输入公告标题', trigger: 'blur' },
            // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
            ],
            subhead: [
            { required: true, message: '请输入副标题', trigger: 'blur' },
            ],
            subContent: [
            { required: true, message: '请输入公告内容', trigger: 'blur' },
            ]
         },
       }
      },
      created(){
       this.getlist(this.subjectQueryDto)
      },
      mounted(){
      },
      methods:{
       getlist(subjectQueryDto) {
          this.$api.gglbqueryPage(subjectQueryDto)
          .then((res) => {
                if (res.data.code == 200) {
                  this.tableData = res.data.data.records
                  this.totals = res.data.data.total
               } else {
               this.$message.error(res.data.message)
               }
          })
       },
       sjhsearchFor(type){
          this.subjectQueryDto.keyWord = type
          this.getlist(this.subjectQueryDto)
       },
       submitForm(formName){
         this.$refs[formName].validate((valid) => {
            if (valid) {
                this.$api.operatorSubject(this.subjectDto).then((res) => {
                if (res.data.code == 200) {
                    this.increase = false
                    this.dialogFormVisible = false
                    this.subjectDto={
                        activeDate:null,
                        endDate:null,
                        remark:null,
                        subContent:null,
                        subhead:null,
                        subjectTitle:null,
                        status:0,
                        subjectId:null
                    }
                    this.getlist(this.subjectQueryDto)
                    this.$message.success(res.data.message)
                } else {
                  this.$message.error(res.data.message)
                }
              })
            } 
          });
      },
      bianjiClick(row) {
         this.subjectDto.subjectId = row.subjectId
         this.dialogFormVisible = true;
         this.bjtsClick(row.subjectId)
      },
      bjtsClick(subjectId){
         this.$api.hqggxqdetail({
            subjectId:subjectId
            }).then((res)=>{
               if (res.data.code == 200) {
                  this.subjectDto = res.data.data
                  } else {
                     this.$message.error(res.data.message)
                  }
            })
      },
      dels(e) {
          this.$confirm('是否确认删除?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.$api.ggdelete({
               subjectId:e.subjectId
                }).then((res) => {
                  if(res.data.code==200){
                     this.getlist(this.subjectQueryDto)
                     this.$message.success(res.data.message)
                  }else{
                     this.$message.error(res.data.message)
                  }
              })
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消删除'
              });          
            });
        },
       newoks() {
         this.increase = true
      },
      closeDialog(){
        this.xgtkdfdqx()
      },
      xgtkdfdqx(){
        this.dialogFormVisible = false;
        this.subjectDto={
            activeDate:null,
            endDate:null,
            remark:null,
            subContent:null,
            subhead:null,
            subjectTitle:null,
            status:0,
            subjectId:null
         }
      },
      handleCurrentChange(val) {
         this.subjectQueryDto.pageNum = val
          this.getlist(this.subjectQueryDto)
      },
      handleSizeChange(val) {
         this.subjectQueryDto.pageSize = val
          this.getlist(this.subjectQueryDto)
      },
      }
      }
   </script>
   <style scoped>
#noticegl {
   width: 100%;
   height: 100%;
   overflow-y: auto;
   background-color: #fff;
   padding:0 0 0 30px;
   box-sizing: border-box;
}
.tos {
   display: flex;
   /* justify-content: space-between; */
   align-items: center;
   /* background: yellow; */
   margin-bottom: 20px;
   margin-left: -30px;
 }
 .elrow{
   box-sizing: border-box;
   width: 20%;
   margin-top: -6px;
   margin: 0 40px 0 20px;
 }
 .elrowleft{
   width: 80%;
   float: left;
   box-sizing: border-box;
 }
 .elrowleft input{
   border: 2px solid #1b93ed !important;
   border-radius: 0 !important;
   width: 100%;
   -webkit-appearance: none;
   appearance: none;
   background-color: #fff;
   background-image: none;
   border-radius: 4px;
   border: 1px solid #929da5;
   box-sizing: border-box;
   color: #1f3d35;
   font-size: 14px;
   height: 36px;
   line-height: 1;
   outline: none;
   padding: 3px 10px;
   transition: border-color .2s cubic-bezier(.645,.045,.355,1);
 }
 .elrowcontent{
   width: 16.66667%;
   float: left;
   box-sizing: border-box;
 }
 .search-btn {
   height: 36px;
   width: 100px;
   background: #1b93ed;
   border: 2px solid #1b93ed;
   margin: 0;
   padding: 0;
   color: #fff;
   cursor: pointer;
 }
 .right-item {
   margin-left: auto; /* Pushes the item to the right */
 }
 .tos /deep/ .el-form-item {
     margin-bottom: 0 !important;
 }
 .btnbox {
   /* background: pink; */
   display: flex;
   width: 40%;
   align-items: center;
   justify-content: space-around;
   margin: auto;
   margin-top: 30px;
}
.zcyhtk /deep/ .el-form-item__label {
   width: 120px !important;
}
.zcyhtk /deep/ .el-form-item__content {
   margin-left: 120px !important;
}
   </style>


// WEBPACK FOOTER //
// src/components/marketivities/noticegl.vue